/** @typedef {import('../../types').ResponseHandler} ResponseHandler */
/** @typedef {import('../../types').ExternalHpaRedirectResponse} ExternalHpaRedirectResponse */


/**
 * @type {ResponseHandler}
 * @param {ExternalHpaRedirectResponse} response
 */
const handle = response => new Promise(() => {
  window.location.href = response.location;
});


export default {
  handle,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/responseHandlers/ExternalHpaRedirectResponseHandler.js